import React from 'react'
import Isvg from 'react-inlinesvg'
import './SocialMedia.scss'

const SocialMedia = ({name, background, backgroundType, icon }) => {

    const componentStyle = backgroundType === 'image' ?
                           {
                               backgroundImage: background
                           } :
                           {
                                backgroundColor: background
                           }
    return (
        <li className="social-icon">
            <div className="icon-container" style={componentStyle}>
                <Isvg src={icon} />
            </div>
            <span>{name}</span>
        </li>
    );
};

export default SocialMedia;


// WEBPACK FOOTER //
// ./src/components/Social/SocialMedia.js